var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _vm.ready
          ? _c(
              "table",
              { staticClass: "table table-hover table-sms table-bordered" },
              [
                _c("thead", [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "tr",
                    _vm._l(_vm.statuses, function (status) {
                      return _c("th", [_vm._v(_vm._s(status.title))])
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.stores, function (store) {
                      return _vm._l(_vm.types, function (title, type, index) {
                        return _c(
                          "tr",
                          [
                            index === 0
                              ? _c("td", { attrs: { rowspan: "2" } }, [
                                  _vm._v(
                                    _vm._s(store.title) +
                                      " (" +
                                      _vm._s(store.id) +
                                      ")"
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(title))]),
                            _vm._v(" "),
                            _vm._l(_vm.statuses, function (status) {
                              return _c(
                                "td",
                                [
                                  _c("NotificationSelect", {
                                    attrs: {
                                      type: type,
                                      value:
                                        _vm.storeSettings[store.id][type][
                                          status.status
                                        ],
                                      onChange: (v) =>
                                        (_vm.storeSettings[store.id][type][
                                          status.status
                                        ] = v),
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        )
                      })
                    }),
                  ],
                  2
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-right" },
          [
            _c("LoadingButton", {
              attrs: {
                title: "Сохранить",
                loading: _vm.loading,
                onClick: _vm.saveRecords,
                className: "btn btn-success",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Настройка уведомлений")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { rowspan: "2", colspan: "2" } }, [_vm._v("Склад")]),
      _vm._v(" "),
      _c("th", { staticClass: "text-center", attrs: { colspan: "4" } }, [
        _vm._v("Статусы заявок"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }